import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Typography, {TypographyProps} from '@material-ui/core/Typography';

import {getMappedValue} from '../../utils/FNUtils';

const TrendWrapper = styled.div<{
    value: number;
}>`
    display: flex;
    align-items: center;
    margin-left: -7px;
    direction: ltr;

    color: ${p =>
        getMappedValue<string>(p.value, {
            positive: p.theme.muiTheme.palette.success.light,
            negative: p.theme.muiTheme.palette.error.light,
            zero: p.theme.muiTheme.palette.text.secondary
        })};

    & > span {
        font-size: 11px;
        font-weight: bold;
    }

    & > svg {
        width: 0.8em;
        height: 0.8em;
        font-size: 1.5rem;
        margin-right: 3px;
    }
`;

const Line = styled.span`
    width: 7px;
    height: 2px;
    margin: 0 7px;
    background-color: ${p => p.theme.muiTheme.palette.text.secondary};
`;

export interface TrendProps {
    value: number;
    valueType?: string;
    TypographyProps?: TypographyProps;
}

const Trend: FC<TrendProps> = ({value, valueType = '%', TypographyProps}: TrendProps) => (
    <TrendWrapper value={value}>
        {getMappedValue<ReactNode>(value, {
            positive: <ArrowDropUpIcon />,
            negative: <ArrowDropDownIcon />,
            zero: <Line />
        })}
        <Typography variant="caption" component="span" {...TypographyProps}>{`${Math.abs(value) ||
            0} ${valueType}`}</Typography>
    </TrendWrapper>
);

export default Trend;
